// core
import React, { useEffect, useRef, useState } from 'react'
import {videoCompleteEvent, videoProgressEvent} from '../assets/js/data-layer';
import {useConsent} from './ConsentContext';

function YouTubeModal({ closeModal, modalDetails, lang, title }) {

  useEffect(() => {
    document.querySelector('body').classList.add('modal-open')
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.querySelector('body').classList.remove('modal-open')
      window.removeEventListener('keydown', handleKeyDown);
    };
  });

  const handleKeyDown = event => {
    if (event.code === 'Escape') {
      closeModal();
    }
  };

  const handleOnOverlayClick = event => {
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };

  const iframeRef=useRef(null);
  const consentAccepted = useConsent()


  useEffect(() => {
    let player;
    let checkInterval;
    let duration = 0;
    let progressPoints = [10, 25, 50, 75, 90, 100];
    let triggeredPoints = new Set();
    let lastProgress = 0;
    let visibility=true

    const loadYTAPI = () => {
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        initPlayer();
      }

      window.onYouTubeIframeAPIReady = () => {
        initPlayer();
      };
    };

    const initPlayer = () => {
      player = new window.YT.Player('video', {
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });
    };

    const onPlayerReady = (event) => {
      duration = event.target.getDuration();
    };

    const onPlayerStateChange = (event) => {
      if (event.data === window.YT.PlayerState.PLAYING) {
        if (!checkInterval) {
          checkInterval = setInterval(() => {
            const currentTime = player.getCurrentTime();
            const percentage = Math.floor((currentTime / duration) * 100);
            document.addEventListener('visibilitychange',() => {
                if(document.visibilityState==='visible') {
                  visibility=true
                } else {
                  visibility=false
                }
            });

            progressPoints.forEach((point) => {
              if (percentage >= point && !triggeredPoints.has(point) && lastProgress < point) {
                lastProgress = percentage;
                triggeredPoints.add(point);
                const dataLayer={
                    videoPercentage: percentage+"%",
                    videoTitle: title||'',
                    videoURL: modalDetails,
                    videoProvider: 'Youtube',
                    videoDuration:duration,
                    videoCurrentTime:currentTime,
                    visible:visibility
                }
                videoProgressEvent(dataLayer,consentAccepted)
              }
            });

            // Stop checking after 100%
            if (triggeredPoints.has(100)) {
              clearInterval(checkInterval);
              checkInterval = null;
            }
          }, 1000); // Check every second
        }
      }

      // Pause or end state
      if (
        event.data === window.YT.PlayerState.PAUSED ||
        event.data === window.YT.PlayerState.ENDED
      ) {
        clearInterval(checkInterval);
        checkInterval = null;
      }
      if(event.data === window.YT.PlayerState.ENDED){
        const dataLayer={
          videoPercentage: 100+"%",
          videoTitle: title||'',
          videoURL: modalDetails,
          videoProvider: 'Youtube',
          videoDuration:duration,
          videoCurrentTime:duration,
          visible:visibility
        }
        videoCompleteEvent(dataLayer,consentAccepted)
      }
    };

    loadYTAPI();

    return () => {
      clearInterval(checkInterval);
    };
  }, []);

  return (<div className='fullscreen-modal'>
        <div className='modal video-popup'  onClick={handleOnOverlayClick}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-close" data-dismiss="modal" onClick={closeModal}>
                  <span className="modal-close__text">Close</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="modal-close__icon">
                    <path d="M0 0h24v24H0V0z" fill="none"></path>
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path>
                  </svg>
                </div>
              </div>
              <div className="modal-body">
                <div className="embed-responsive-item embed-responsive-16by9">
                  <iframe
                      ref={iframeRef}
                      id="video"
                      className="w-100"
                      title='White Claw'
                      src={`${modalDetails}?autoplay=1&amp;modestbranding=1&amp;showinfo=0&amp;rel=0&enablejsapi=1`}
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                      allowFullScreen
                  >
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default YouTubeModal;